module.exports = __webpack_public_path__ + "img/good-white.04536962.svg";